import styled from "styled-components";
import { getTheme, themed, Box, Text as Tx, } from "@bracket/ui";


export declare type PilledTab = {
	id: string;
	label: string;
};

export declare type PilledTabsProps = {
	items: PilledTab[];
	activeTab: string;
	onTabChange: (tabId: string) => void;
	top?: string;
	right?: string;
	containerStyle?: React.CSSProperties;
};



export const PilledTabs: React.FC<PilledTabsProps> = ({
	items,
	activeTab,
	onTabChange,
	top,
	right,
	containerStyle,
}) => {
	themed();
	return (
		<PilledTabsContainer $top={top} $right={right}>
			{items.map((item) => (
				<PilledTab key={item.id} isActive={item.id === activeTab} onClick={() => onTabChange(item.id)}>
					<Tx sm color={item.id === activeTab ? "heading" : "surface_on"}>{item.label}</Tx>
				</PilledTab>
			))}
		</PilledTabsContainer>
	);
};

export const PilledTab = ({ children, isActive, onClick, }: { children: React.ReactNode, isActive: boolean, onClick: () => void }) => {
	return <PilledTabBrace $isActive={isActive} onClick={onClick}>{children}</PilledTabBrace>;
};

const PilledTabsContainer = styled(Box)<{ $top?: string; $right?: string }>`
	background: ${() => getTheme().surface_container_low};
	padding: 4px;
	border-radius: ${() => getTheme().radials.sm};
	// mobile exclusive below.
	@media (max-width: 1023px) {
		flex: 1;
		> button {
			display: flex;
			flex: 1;
			padding: 1rem;
			text-align: center;
			> div {
				width: 100%;
				text-align: center;
			}
		}
	}

	// desktop exclusive below.
	@media (min-width: 1023px) {
		position: relative;
		align-self: flex-end;
	}
`;

const PilledTabBrace = styled(Box)<{ $isActive?: boolean }>`
	padding: 0.25rem 1rem;
	border-radius: ${() => getTheme().radials.xsm};
	cursor: pointer;
	user-select: none;
	white-space: nowrap;
	background: none;
	transition: all 250ms ease;
	${({ $isActive }) => !$isActive && `opacity: 0.25;`}
	${({ $isActive }) => $isActive && `background-color: ${getTheme().surface_variant};`}

	&:hover {
		background-color: ${() => getTheme().surface_variant};
		opacity: 1;
		scale: 1.05;
	}
`;
